import React, { Component } from 'react'
import toastr from 'toastr'
import { AgGridReact } from "ag-grid-react"
import { Button, Dropdown, Form } from "semantic-ui-react"
import ApiHelper from "services/api-helper"
import QuanLyUserTaoMoi from 'components/quan-ly-users/tao-moi-modal';

class QuanLyUsers extends Component {
  state = {
    rowData: [],
    columnDefs: [
      { checkboxSelection: true, minWidth: 40, maxWidth: 40 },
      {
        headerName: "#",
        minWidth: 50,
        maxWidth: 50,
        suppressSorting: true,
        cellRenderer: function (params) {
          return params.rowIndex + 1;
        }
      },
      { headerName: "Username", field: "UserName" },
      { headerName: "Họ tên", field: "HoTen" },
      { headerName: "Bộ phận", field: "TenBoPhan" },
      { headerName: "Loại tài khoản", field: "WebGroupName" },
      {
        headerName: "Hoạt động", field: "HoatDong",
        cellRenderer: function (data) {
          if (data.value === true)
            return '<input type="checkbox" disabled checked />'
          else return '<input type="checkbox" disabled />'
        }
      }
    ],
    boPhanList: [],
    boPhanSelected: null,
    openModal: false
  }
  getListBoPhan() {
    ApiHelper.GetJson('api/getDanhSachBoPhanByUser').then(res => {
      if (res.length > 1) res.unshift({ Oid: null, TenBoPhan: 'Tất cả' })
      this.setState({ boPhanList: res, boPhanSelected: res.length > 0 ? res[0].Oid : null })
      this.getData()
    }, error => {
      toastr.error(error)
    })
  }
  getData = () => {
    ApiHelper.GetJson('api/getUsers', {
      IDBoPhan: this.state.boPhanSelected
    }).then(res => {
      this.setState({ rowData: res })
      this.autoSizeAll()
    }, error => {
      toastr.error(error)
    })
  }
  onGridReady = (params) => {
    this.gridApi = params.api
    this.gridColumnApi = params.columnApi
    this.getListBoPhan()
  }
  autoSizeAll() {
    this.gridApi.sizeColumnsToFit()
    var widthAfterSizeColsToFit = this.gridColumnApi.getAllColumns().map(column => column.getActualWidth()).reduce((a, b) => a + b, 0)
    this.gridColumnApi.autoSizeAllColumns()
    var widthAfterAutoSize = this.gridColumnApi.getAllColumns().map(column => column.getActualWidth()).reduce((a, b) => a + b, 0)
    if (widthAfterSizeColsToFit > widthAfterAutoSize) {
      this.gridApi.sizeColumnsToFit()
    }
  }
  handleBoPhanSelected = (e, { value }) => {
    return this.setState({ boPhanSelected: value })
  }
  updateModalState = (openModal) => {
    this.setState({ openModal })
    if (!openModal) this.getData()
  }
  lock = () => {
    const selectedNodes = this.gridApi.getSelectedRows()
    if (selectedNodes.length < 1) {
      toastr.warning('Chưa có dòng nào được chọn')
      return
    }
    if (!window.confirm('Bạn muốn dừng hoạt động tài khoản này?')) {
      return
    }
    ApiHelper.PostJson('api/User/UpdateLock', {
      Oid: selectedNodes.map(q => q.Oid).join(','),
    }).then(res => {
      if (res.ok) {
        toastr.success('Thành công')
        this.getData()
      } else {
        toastr.error('Thất bại')
      }
    }, error => {
      toastr.error(error)
    })
  }
  delete = () => {
    const selectedNodes = this.gridApi.getSelectedNodes().map(q => q.data)
    if (selectedNodes.length < 1) {
      toastr.warning('Chưa có dòng nào được chọn')
      return
    }
    if (!window.confirm('Bạn muốn xóa tài khoản này?')) {
      return
    }
    ApiHelper.PostJson('api/User/Delete', {
      Oid: selectedNodes.map(q => q.Oid).join(','),
    }).then(res => {
      if (res.ok) {
        toastr.success('Thành công')
        this.getData()
      } else {
        toastr.error('Thất bại')
      }
    }, error => {
      toastr.error(error)
    })
  }
  render() {
    const boPhanList = this.state.boPhanList.map(item => {
      return { value: item.Oid, text: item.TenBoPhan }
    })
    return (
      <div>
        <Form>
          <Form.Group className="ui center aligned grid">
            <Form.Field>
              <Button onClick={() => this.updateModalState(true)} positive>Thêm mới</Button>
            </Form.Field>
            <Form.Field>
              <Button onClick={() => this.lock()} secondary>Dừng hoạt động</Button>
            </Form.Field>
            <Form.Field>
              <Button onClick={() => this.delete()} negative>Xóa</Button>
            </Form.Field>
          </Form.Group>
          <Form.Group className="ui center aligned grid">
            <Form.Field>
              <Dropdown selection options={boPhanList} placeholder={boPhanList.map(q => q.text)[0]}
                value={this.state.boPhanSelected}
                onChange={this.handleBoPhanSelected}
              />
            </Form.Field>
            <Form.Field>
              <Button onClick={this.getData} color="twitter">Tìm</Button>
            </Form.Field>
          </Form.Group>
        </Form>
        <div className="ag-theme-balham" style={{ height: '500px' }}>
          <AgGridReact
            enableSorting={true}
            rowSelection="multiple"
            enableFilter={true}
            enableColResize={true}
            suppressColumnVirtualisation={true}
            onGridReady={this.onGridReady}
            columnDefs={this.state.columnDefs}
            rowData={this.state.rowData}>
          </AgGridReact>
        </div>
        {this.state.openModal &&
          <QuanLyUserTaoMoi openModal={this.state.openModal} closeModal={() => this.updateModalState(false)} />
        }
      </div>
    )
  }
}

export default QuanLyUsers


// WEBPACK FOOTER //
// ./src/components/quan-ly-users/index.jsx